const data = [
    { 
        id: 1, 
        name: 'Documento de identificação', 
    },
    { 
        id: 2, 
        name: 'Procuração',
    },
    { 
        id: 3, 
        name: 'Documentos comprobatórios',
    },
    { 
        id: 4, 
        name: 'Documento do procurador',
    },
    // { 
    //     id: 5, 
    //     name: 'Planilha de Cálculos',
    // },
    // { 
    //     id: 6, 
    //     name: 'Outros',
    // },
];

export default [...data];